<template>
  <!-- <a href="#" class="brand-logo"> -->
  <router-link to="/" class="brand-logo">
    <div v-if="!domainBasedBrand">
      <svg width="125" height="40" fill="none">
        <use xlink:href="#brandLogo" />
      </svg>
    </div>
    <div v-else>
      <img
        id="logo"
        class="img-fluid logo-image-header"
        :class="{
          'short-logo': $route.name !== 'home',
          'mobile-logo': currentBrand.web_logo_issqr,
        }"
        :style="{
          borderRadius:
            currentBrand.web_logo_issqr && $route.name === 'home'
              ? '50%'
              : null,
        }"
        :src="
          currentBrand.web_logo_issqr
            ? currentBrand.web_logo_sqr
            : currentBrand.web_logo
        "
      />
    </div>
  </router-link>
  <!-- </a> -->
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Logo',
  computed: {
    ...mapGetters(['_T', 'domainBasedBrand', 'currentBrand']),
  },
}
</script>

<style lang="scss" scoped>
#logo {
  max-height: 80px !important;
  margin-top: -15px !important;
}
.body-rtl {
  .brand-logo {
    margin-right: unset !important;
    margin-left: $px12;
  }
}
.brand-logo {
  margin-right: auto;
  max-height: $px50;
  z-index: 2;
  &.center-logo {
    position: absolute;
    margin-right: 0;
    left: 50%;
    transform: translateX(-50%);
    margin-left: auto;
  }
  .img-fluid {
    max-width: $px150 !important;
    height: auto !important;
    cursor: pointer;
    @media (max-width: 575px) {
      max-height: 4rem !important;
      width: auto;
      max-width: auto !important;
      border-radius: 7% !important;
    }
  }
  .short-logo {
    border-radius: $px10;
    display: flex;
    max-height: $px72;
    overflow: hidden;
  }
  .mobile-logo {
    @media (max-width: 575px) {
      margin-left: $px3;
      max-height: 4rem !important;
      width: auto;
      max-width: auto !important;
    }
  }
}
</style>
